export default function isNullEmptyOrUndefined(value: any): boolean {
  return value === null || value === undefined || value === "";
}
